import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IOrderMSService, IOrderServiceOrder } from '~/types/order/models'
import { OrderServiceOrder } from '~/cynqueModules/dataObjects/OrderServiceOrder'
import { ItemAvailabilityIds } from '~/cynqueModules/dataObjects/ItemAvailabilityStatus'

const apiEntityPath = '/api/orderserviceorders'

export async function getOrderServiceOrders({ apiPath = apiEntityPath } = {}) {
  const callingMn = getOrderServiceOrders.name
  return httpGet<IOrderServiceOrder[]>({ callingMn, apiPath })
}

export async function getOrderServiceOrdersForOrderAndSupplierPreProcessed(
  orderId: TEntityId,
  supplierId: TEntityId
) {
  const apiPath = `/api/orders/${orderId}/orderserviceorders`
  const callingMn = getOrderServiceOrdersForOrderAndSupplierPreProcessed.name
  const rawOrderServiceOrder = await httpGet<IOrderServiceOrder[]>({
    callingMn,
    apiPath,
  })
  const filteredOrderServiceOrder =
    rawOrderServiceOrder.filter(
      (orderServiceOrder) => orderServiceOrder.supplier?.id === supplierId
    ) ?? []
  return filteredOrderServiceOrder.map((filteredOrderServiceOrder) =>
    OrderServiceOrder(filteredOrderServiceOrder)
  )
}

export async function getOrderServiceOrderOrderMSServices(id: TEntityId) {
  const apiPath = `${apiEntityPath}/${id}/ordermsservices`
  const callingMn = getOrderServiceOrderOrderMSServices.name
  const orderMSServices = await httpGet<IOrderMSService[]>({
    callingMn,
    apiPath,
  })
  // Skip all optional orderMSServices not included
  const filteredOrderMSServices = orderMSServices.filter(
    (momss) =>
      momss.itemAvailabilityState.id === ItemAvailabilityIds.MANDATORY ||
      momss.itemAvailabilityState.id === ItemAvailabilityIds.OPTIONAL_INCLUDED
  )
  return filteredOrderMSServices
}

export async function createOrderServiceOrder(entity: IOrderServiceOrder) {
  const callingMn = createOrderServiceOrder.name
  const apiPath = apiEntityPath
  return httpPost<IOrderServiceOrder>({ callingMn, apiPath, entity })
}

export async function updateOrderServiceOrder(
  entityData: Partial<IOrderServiceOrder>,
  id: TEntityId
) {
  const callingMn = updateOrderServiceOrder.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIOrderServiceOrder = Partial<IOrderServiceOrder>
  return httpPatchMerge<TPartialIOrderServiceOrder>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOrderServiceOrder(entityData: IOrderServiceOrder) {
  const callingMn = deleteOrderServiceOrder.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
